module.exports = __webpack_public_path__ + "img/landing-treatment-screen-3.3fa076a4.png";